<template>
  <div>
    <div class="body_admin">
      <div class="left_color full_height">.</div>
      <div class="application_layout">
        <header
          id="header"
          class="u-header--starter"
        >
          <nav
            id="logoAndNav"
            class="navbar navbar-dark lex-nowrap bg_menu p-0 bg-white"
            style="border-bottom: 1px solid #937ed0"
          >
            <inertia-link
              href="/recruiters/limited_jobs"
              class="m-3"
            >
              <img
                src="/images/Jovool_logo.png"
                width="120px"
              />
            </inertia-link>

            <div
              class="input-group input-group-xs input-group-borderless d-md-flex mr-auto ml-md-4"
              style="max-width: 700px"
            >
              <div class="input-group-prepend hide">
                <span
                  class="input-group-text bg-primary2"
                  id="docsSearch"
                >
                  <span class="fas fa-search"></span>
                </span>
              </div>
              <input
                id="input_search"
                class="js-hs-docs-search hide form-control pl-0 ui-autocomplete-input"
                type="text"
                placeholder="Pesquisar..."
                style="height: 36px; padding-right: 5px"
                aria-label="Pesquisar..."
                aria-describedby="docsSearch"
              />
            </div>

            <div class="mr-3">
              <button class="hidebtn hide btn-outline-success">
                Upgrade Plan
              </button>
            </div>
            <CalendarButton></CalendarButton>
            <div
              class="dropdown white_font"
              style="margin-right: 5px; user-select: none"
            >
              <a
                class="dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  :src="picture || null"
                  class="img_avatar_small"
                />
              </a>
              <div
                class="dropdown-menu p-2 bg-light-grey"
                style="margin-left: -90px"
                aria-labelledby="dropdownMenuButton"
              >
                <button
                  @click="logout"
                  class="btn full mt-1 mb-1 btn-dark user-dropdown-item"
                >
                  Logout
                </button>
              </div>
            </div>
          </nav>
        </header>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import axios from "axios";
import CalendarButton from "@/Recruiters/Calendar/CalendarButton.vue";

export default {
  components: { CalendarButton },
  data() {
    return {
      picture: null,
    }
  },
  methods: {
    logout() {
      axios
        .delete("/admins/sign_out")
        .then((resource) => {
          // console.log(resource);
          window.location = "/";
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
